<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card v-if="ShowRegister">
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img  v-if="setRegisterPageImage" :src="img_cdn + setRegisterPageImage" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Register</h4>
                </div>

                <div v-on:keyup.enter="submitData">
                  <vs-input
                    v-validate="'required|min:3'"
                    data-vv-validate-on="blur"
                    name="First Name"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="First Name *"
                    v-model="fname"
                    class="w-full mt-6"/>
                  <span class="text-danger text-sm">{{ errors.first('First Name') }}</span>

                      <vs-input
                        name="middleName"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        label-placeholder="Middle Name"
                        v-model="middle_name"
                        class="w-full mt-6"/>


                      <vs-input
                        v-validate="'required|min:3'"
                        data-vv-validate-on="blur"
                        name="Last Name"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        label-placeholder="Last Name *"
                        v-model="lname"
                        class="w-full mt-6"/>

                      <span class="text-danger  text-sm">{{ errors.first('Last Name') }}</span>


                  <vs-input
                    v-validate="'required|alpha_num'"
                    name="Username"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Username *"
                    v-model="username"
                    @input="checkUserName"
                    class="w-full mt-6"/>
                  <span class="text-danger text-sm">{{ errors.first('Username') }}</span>
                  <span class="text-danger text-sm" v-if="UserDuplicate>0">Username has already been taken !</span>
                  <vs-input
                    @input="acceptNumber"
                    name="phoneNo"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Phone Number"
                    v-model="phone"
                    class="w-full mt-6"/>
                  <span v-if="phone.length > 0 &&  phone.length < 14" class="text-danger text-sm">Invalid phone number format.</span>


                  <vs-input
                    @input="acceptEmail"
                    v-validate="'required|email'"
                    name="email"
                    icon-no-border
                    icon="icon icon-mail"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full mt-6"/>
                  <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                  <span class="text-danger text-sm" v-if="Duplicate>0">Email has already been taken !</span>
                  <br>
                  <vx-input-group>
                  <template slot="append">
                    <div class="append-text cursor-pointer" style="color:#B0AFB7;background-color:white;border:1px solid rgba(0, 0, 0, 0.2); border-left:none">
                      <span @click="showPassword = !showPassword">
                              <feather-icon v-if="showPassword" icon="EyeOffIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                              <feather-icon v-else icon="EyeIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                        </span>
                    </div>
                  </template>

                  <vs-input 
                  ref="password"
                  v-model="password" 
                   icon="icon icon-lock"
                   icon-pack="feather"
                   icon-no-border
                   data-vv-validate-on="blur"
                   v-validate="'required|min:6|max:20'"
                    v-bind:type="[showPassword ? 'text' : 'password']" 
                    name="password"
                    placeholder="Password"
                    class="w-full no-right-border"
                  />
                </vx-input-group>
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                  <vs-input
                    type="password"
                    v-validate="'min:6|max:20|confirmed:password'"
                    data-vv-validate-on="blur"
                    data-vv-as="password"
                    name="confirm_password"
                    label-placeholder="Confirm Password"
                    placeholder="Confirm Password"
                    v-model="password_confirmation"
                    class="w-full mt-6" />
                  <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>
               <br>
                     <label class="vs-select--label w-full">{{ $t('menu.students.name') }} </label>
                  <vs-textarea
                    label=""
                    id="textid"
                    v-model="dataStudentText"
                    name="message"
                    v-validate="'required'"
                  />
                   <!-- <div class="mb-5">
                  <label class="vs-select--label w-full">Select Location</label>
                  <v-select   label="name"   :closeOnSelect="true" v-model="dataLocation" :options="locations"   />
                  </div>
                    <div class="mb-base" v-if="dataLocation  && dataLocation.is_signup">
                    <ul class="centerx">
                      <li class="flex">
                        <vs-checkbox v-model="dataLocationCode">Code</vs-checkbox>
                         <vs-input placeholder="Enter Code" v-if="dataLocationCode" v-model="matched_code" class="w-full"></vs-input>
                      </li>
                    </ul>
                  </div> -->
                  <router-link to="/login">
                    <vs-button type="border">Cancel</vs-button>
                  </router-link>
                  <vs-button class="float-right" @click.native="submitData" :disabled="!validateForm">Register</vs-button>

                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
      <vx-card v-if="ShowLocationCode">
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/lock-screen.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Enter Location Code</h4>
                                </div>
                                <vs-input  label-placeholder="Location Code" v-model="LocationCode" name="Location Code" class="w-full" v-validate="'required'"/>
                                 <span class="text-danger text-sm">{{ errors.first('Location Code') }}</span>
                                <div class="flex justify-between flex-wrap mt-6">
                                <vs-button class="ml-2" @click.native="checkLocation()">Next</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
    </div>

  </div>
  
</template>

<script>
import vSelect from 'vue-select'
import {GET_IMAGE_SETTING, SIGNUP_MUTATION, SINGLE_USER_BY_EMAIL, SINGLE_USER_BY_USERNAME,CHECK_LOCATION_CODE} from '@/graphql'


export default {
  computed: {
    validateForm () {
      return !this.errors.any() && this.fname !== '' && this.lname !== '' && this.username !== '' && this.email !== '' && this.password !== '' && this.password_confirmation !== '' && this.UserDuplicate === 0 && this.Duplicate === 0 && (this.phone == '' || this.phone.length == 14)
    }
  },
  data () {
    return {
      fname: '',
      lname: '',
      middle_name: '',
      username: '',
      phone: '',
      email: '',
      password: '',
      password_confirmation: '',
      checkbox_remember_me: false,
      UserDuplicate:0,
      userPinTime:'',
      Duplicate:0,
      img_cdn:process.env.VUE_APP_IMAGES_CDN_LINK,
      setRegisterPageImage:'',
      param: null,
      ShowRegister:false,
      ShowLocationCode:true,
      LocationCode:null,
      dataStudentText:null,
      showPassword:false,
      // dataLocationCode:true,
      // matched_code:null,
      // locations:[],
      // dataLocation:null

    }
  },
    components: {
    'v-select': vSelect
  },
  methods: {
     checkLocation() {
      this.$validator.validateAll().then(result => {
        if(result) {
        this.$apollo
        .mutate({
          mutation: CHECK_LOCATION_CODE,
          variables: {
            code: this.LocationCode
          }
        })
        .then(response => {
          if(response.data.checkLocationCode.check){
            // alert(response.data.checkLocationCode.check)
             this.ShowRegister=true
            //  this.LocationCode=null
             this.ShowLocationCode=false
          }
          else{
              this.LocationCode=null
              this.$vs.notify({
              title: 'Failed',
              text: 'The code is invalid.',
              color: 'danger',
              iconPack: 'feather',
              position: 'top-center',
              icon:'icon-alert-circle'
            })
          }
          // window.location = '/pages/error-404'

        })
        }
      })
    },
    acceptNumber () {
      const x = this.phone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.phone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    checkUserName () {
      const letterNumber = /[^a-zA-Z0-9]/g
      if (this.username.match(letterNumber)) {
      } else if (this.username) {
        this.$apollo
          .mutate({
            mutation: SINGLE_USER_BY_USERNAME,
            variables: {
              username: this.username
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.userByUserName.length
          })
      }
    },
    acceptEmail () {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email: this.email
          }
        })
        .then(response => {
          this.Duplicate = response.data.userByEmail.length
        })
    },
    submitData () {
      // alert(this.LocationCode)
      // let code 
      // let location 
      // if (this.param == undefined) {
      //   this.param = ''
      // }
      // if (this.dataLocationCode) {
      //   code = this.matched_code
      // }
      // if(this.dataLocation){
      //    location = this.dataLocation.id
      // }
      this.$apollo
        .mutate({
          mutation: SIGNUP_MUTATION,
          variables: {
            fname: this.fname,
            middle_name: this.middle_name,
            lname: this.lname,
            username: this.username,
            phone: this.phone,
            email: this.email,
            password: this.password,
            param:this.LocationCode,
            details:this.dataStudentText,
            // isLocationCode:this.dataLocationCode,
            // location:location,
            // code

          }
        })
        .then(response => {
          localStorage.removeItem('userPinTime')
          if (response.data.register.status == 'MUST_VERIFY_EMAIL') {

            localStorage.setItem('userPinTime', response.data.register.pin_time)

            // this.$router.push('/verify-email')
            window.location = '/verify-email'
            this.SuccessStatus()
          }
        }).catch(error => {
          this.StatusInvalid()
        })
    },
    SuccessStatus () {
      this.$vs.notify({
        title: 'User',
        text: 'Registerd Sucessfully',
        color: 'success',
        position: 'top-right'
      })
    },
    StatusInvalid () {
      this.$vs.notify({
        title: 'Incorrect Data',
        text: 'Check and Enter again',
        color: 'danger',
        position: 'top-right'
      })
    }
  },
  beforeCreate () {
    this.$apollo
      .query({
        query: GET_IMAGE_SETTING
      })
      .then(response => {
        if (response.data.getImagesSetting.register_page_image != null) {
          this.setRegisterPageImage = response.data.getImagesSetting.register_page_image
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  created () {
    if(this.$route.params.code){
        this.ShowRegister=false
        this.ShowLocationCode=false
        this.LocationCode=this.$route.params.code
        this.checkLocation()
        // this.ShowRegister=true
    }
    else{
      this.ShowRegister=false
      this.ShowLocationCode=true
      this.LocationCode=null
    }
    // this.param = this.$route.params.code
        //  this.$apollo
        //   .mutate({
        //     mutation: DROPDOWN_ALL_LOCATIONS
        //   })
        //   .then(response => {
        //     this.locations = response.data.dropdownlocations

        //   })
  }

}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }
}
</style>
